export default "__VITE_ASSET__CfsguHtb__"